import { call, put, takeEvery } from 'redux-saga/effects'
import { API } from '../../services'

import {
  // Tutor Type
  getTutorTypeListApiData,
  getTutorTypeListApiSuccess,
  getTutorTypeListApiFailed,
  getTutorTypeDetailsApiData,
  getTutorTypeDetailsApiSuccess,
  getTutorTypeDetailsApiFailed,
  addTutorTypeApiData,
  addTutorTypeApiSuccess,
  addTutorTypeApiFailed,
  updateTutorTypeApiData,
  updateTutorTypeApiSuccess,
  updateTutorTypeApiFailed,
  deleteTutorTypeApiData,
  deleteTutorTypeApiSuccess,
  deleteTutorTypeApiFailed,
  activeInactiveTutorTypeApiData,
  activeInactiveTutorTypeApiSuccess,
  activeInactiveTutorTypeApiFailed,

  // Tutor Category
  getTutorCategoryListApiData,
  getTutorCategoryListApiSuccess,
  getTutorCategoryListApiFailed,
  getTutorCategoryDetailsApiData,
  getTutorCategoryDetailsApiSuccess,
  getTutorCategoryDetailsApiFailed,
  addTutorCategoryApiData,
  addTutorCategoryApiSuccess,
  addTutorCategoryApiFailed,
  updateTutorCategoryApiData,
  updateTutorCategoryApiSuccess,
  updateTutorCategoryApiFailed,
  deleteTutorCategoryApiData,
  deleteTutorCategoryApiSuccess,
  deleteTutorCategoryApiFailed,
  activeInactiveTutorCategoryApiData,
  activeInactiveTutorCategoryApiSuccess,
  activeInactiveTutorCategoryApiFailed,

  // Tutor Sub Category
  getTutorSubCategoryListApiData,
  getTutorSubCategoryListApiSuccess,
  getTutorSubCategoryListApiFailed,
  getTutorSubCategoryDetailsApiData,
  getTutorSubCategoryDetailsApiSuccess,
  getTutorSubCategoryDetailsApiFailed,
  addTutorSubCategoryApiData,
  addTutorSubCategoryApiSuccess,
  addTutorSubCategoryApiFailed,
  updateTutorSubCategoryApiData,
  updateTutorSubCategoryApiSuccess,
  updateTutorSubCategoryApiFailed,
  deleteTutorSubCategoryApiData,
  deleteTutorSubCategoryApiSuccess,
  deleteTutorSubCategoryApiFailed,
  activeInactiveTutorSubCategoryApiData,
  activeInactiveTutorSubCategoryApiSuccess,
  activeInactiveTutorSubCategoryApiFailed,

  // Tutor Curriculum
  getTutorCurriculumListApiData,
  getTutorCurriculumListApiSuccess,
  getTutorCurriculumListApiFailed,
  getTutorCurriculumDetailsApiData,
  getTutorCurriculumDetailsApiSuccess,
  getTutorCurriculumDetailsApiFailed,
  addTutorCurriculumApiData,
  addTutorCurriculumApiSuccess,
  addTutorCurriculumApiFailed,
  updateTutorCurriculumApiData,
  updateTutorCurriculumApiSuccess,
  updateTutorCurriculumApiFailed,
  deleteTutorCurriculumApiData,
  deleteTutorCurriculumApiSuccess,
  deleteTutorCurriculumApiFailed,
  activeInactiveTutorCurriculumApiData,
  activeInactiveTutorCurriculumApiSuccess,
  activeInactiveTutorCurriculumApiFailed,

  // Tutor List
  getTutorListApiData,
  getTutorListApiSuccess,
  getTutorListApiFailed,
  getTutorDetailsApiData,
  getTutorDetailsApiSuccess,
  getTutorDetailsApiFailed,
  activeInactiveTutorApiData,
  activeInactiveTutorApiSuccess,
  activeInactiveTutorApiFailed,
  tutorVerificationApiData,
  tutorVerificationApiSuccess,
  tutorVerificationApiFailed,

  // State (tutor list filter)
  getTutorStateListApiData,
  getTutorStateListApiSuccess,
  getTutorStateListApiFailed,

  // Country (common)
  getCountryListApiData,
  getCountryListApiSuccess,
  getCountryListApiFailed,
} from './slice'

// ================= Tutor Type =================
function* getTutorTypeListApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorTypeList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorTypeListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorTypeListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorTypeListApiFailed({ message: error?.message }))
  }
}

function* getTutorTypeDetailsApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorTypeDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorTypeDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorTypeDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorTypeDetailsApiFailed({ message: error?.message }))
  }
}

function* addTutorTypeApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.addTutorType, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addTutorTypeApiSuccess({ payload: response?.data }))
    } else {
      yield put(addTutorTypeApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addTutorTypeApiFailed({ message: error?.message }))
  }
}

function* updateTutorTypeApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.updateTutorType, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateTutorTypeApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateTutorTypeApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateTutorTypeApiFailed({ message: error?.message }))
  }
}

function* deleteTutorTypeApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.deleteTutorType, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(deleteTutorTypeApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteTutorTypeApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteTutorTypeApiFailed({ message: error?.message }))
  }
}

function* activeInactiveTutorTypeApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.activeInactiveTutorType, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(activeInactiveTutorTypeApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveTutorTypeApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(activeInactiveTutorTypeApiFailed({ message: error?.message }))
  }
}

// ================= Tutor Category =================
function* getTutorCategoryListApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorCategoryListApiFailed({ message: error?.message }))
  }
}

function* getTutorCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorCategoryDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorCategoryDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorCategoryDetailsApiFailed({ message: error?.message }))
  }
}

function* addTutorCategoryApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.addTutorCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addTutorCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addTutorCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addTutorCategoryApiFailed({ message: error?.message }))
  }
}

function* updateTutorCategoryApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.updateTutorCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateTutorCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateTutorCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateTutorCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteTutorCategoryApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.deleteTutorCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(deleteTutorCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteTutorCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteTutorCategoryApiFailed({ message: error?.message }))
  }
}

function* activeInactiveTutorCategoryApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.activeInactiveTutorCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(activeInactiveTutorCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveTutorCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(activeInactiveTutorCategoryApiFailed({ message: error?.message }))
  }
}

// ================= Tutor Sub Category =================
function* getTutorSubCategoryListApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorSubCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorSubCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorSubCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorSubCategoryListApiFailed({ message: error?.message }))
  }
}

function* getTutorSubCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorSubCategoryDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorSubCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorSubCategoryDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorSubCategoryDetailsApiFailed({ message: error?.message }))
  }
}

function* addTutorSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.addTutorSubCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addTutorSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addTutorSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addTutorSubCategoryApiFailed({ message: error?.message }))
  }
}

function* updateTutorSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.updateTutorSubCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateTutorSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateTutorSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateTutorSubCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteTutorSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.deleteTutorSubCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(deleteTutorSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteTutorSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteTutorSubCategoryApiFailed({ message: error?.message }))
  }
}

function* activeInactiveTutorSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.activeInactiveTutorSubCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(activeInactiveTutorSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveTutorSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(activeInactiveTutorSubCategoryApiFailed({ message: error?.message }))
  }
}

// ================= Tutor Curriculum =================
function* getTutorCurriculumListApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorCurriculumList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorCurriculumListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorCurriculumListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorCurriculumListApiFailed({ message: error?.message }))
  }
}

function* getTutorCurriculumDetailsApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorCurriculumDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorCurriculumDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorCurriculumDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorCurriculumDetailsApiFailed({ message: error?.message }))
  }
}

function* addTutorCurriculumApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.addTutorCurriculum, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addTutorCurriculumApiSuccess({ payload: response?.data }))
    } else {
      yield put(addTutorCurriculumApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addTutorCurriculumApiFailed({ message: error?.message }))
  }
}

function* updateTutorCurriculumApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.updateTutorCurriculum, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateTutorCurriculumApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateTutorCurriculumApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateTutorCurriculumApiFailed({ message: error?.message }))
  }
}

function* deleteTutorCurriculumApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.deleteTutorCurriculum, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(deleteTutorCurriculumApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteTutorCurriculumApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteTutorCurriculumApiFailed({ message: error?.message }))
  }
}

function* activeInactiveTutorCurriculumApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.activeInactiveTutorCurriculum, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(activeInactiveTutorCurriculumApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveTutorCurriculumApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(activeInactiveTutorCurriculumApiFailed({ message: error?.message }))
  }
}

// ================= Tutor List =================
// 409 / 400 come back as axios errors, so read the API message from error.response first
const getApiErrorMessage = (error) =>
  error?.response?.data?.message || error?.response?.data?.detail?.[0]?.msg || error?.message

function* getTutorListApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorListApiFailed({ message: getApiErrorMessage(error) }))
  }
}

function* getTutorDetailsApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorDetailsApiFailed({ message: getApiErrorMessage(error) }))
  }
}

function* activeInactiveTutorApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.activeInactiveTutor, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(activeInactiveTutorApiSuccess({ payload: response?.data }))
    } else {
      yield put(activeInactiveTutorApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(activeInactiveTutorApiFailed({ message: getApiErrorMessage(error) }))
  }
}

// API sometimes answers HTTP 200 with { error: true, status: 400 } in the body
const isVerificationResponseOk = (response) =>
  !!response?.data &&
  (response?.status === 200 || response?.status === 201) &&
  !response?.data?.error

// payload.reopen = true -> tutor is already Approved / Rejected:
//   step 1: submit "Pending" to reopen the review (API never overwrites a decision)
//   step 2: send the new decision (Approved / Rejected)
function* tutorVerificationApi({ payload }) {
  const { reopen, ...verificationData } = payload || {}
  let reviewReopened = false

  try {
    if (reopen) {
      const reopenResponse = yield call(API.tutorManagement.tutorVerification, {
        tutor_id: verificationData.tutor_id,
        status: 'Pending',
        created_by: verificationData.updated_by,
        created_by_id: verificationData.updated_by_id,
        updated_by: verificationData.updated_by,
        updated_by_id: verificationData.updated_by_id,
      })

      if (!isVerificationResponseOk(reopenResponse)) {
        yield put(
          tutorVerificationApiFailed({
            message: reopenResponse?.data?.message || 'Could not reopen the review',
          }),
        )
        return
      }
      reviewReopened = true
    }

    const response = yield call(API.tutorManagement.tutorVerification, verificationData)
    if (isVerificationResponseOk(response) || (!reopen && response?.data)) {
      // direct (Pending) flow keeps the old behaviour: body error is shown by the success reducer
      yield put(tutorVerificationApiSuccess({ payload: response?.data }))
    } else {
      yield put(
        tutorVerificationApiFailed({
          message: response?.data?.message || response?.message,
          reviewReopened,
        }),
      )
    }
  } catch (error) {
    yield put(
      tutorVerificationApiFailed({ message: getApiErrorMessage(error), reviewReopened }),
    )
  }
}

// ================= State (tutor list filter) =================
function* getTutorStateListApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getTutorStateList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getTutorStateListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getTutorStateListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getTutorStateListApiFailed({ message: error?.message }))
  }
}

// ================= Country (common) =================
function* getCountryListApi({ payload }) {
  try {
    const response = yield call(API.tutorManagement.getCountryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getCountryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getCountryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getCountryListApiFailed({ message: error?.message }))
  }
}

/* ============================
      Root Saga
=============================== */
function* tutorManagementSaga() {
  // Tutor Type
  yield takeEvery(getTutorTypeListApiData, getTutorTypeListApi)
  yield takeEvery(getTutorTypeDetailsApiData, getTutorTypeDetailsApi)
  yield takeEvery(addTutorTypeApiData, addTutorTypeApi)
  yield takeEvery(updateTutorTypeApiData, updateTutorTypeApi)
  yield takeEvery(deleteTutorTypeApiData, deleteTutorTypeApi)
  yield takeEvery(activeInactiveTutorTypeApiData, activeInactiveTutorTypeApi)

  // Tutor Category
  yield takeEvery(getTutorCategoryListApiData, getTutorCategoryListApi)
  yield takeEvery(getTutorCategoryDetailsApiData, getTutorCategoryDetailsApi)
  yield takeEvery(addTutorCategoryApiData, addTutorCategoryApi)
  yield takeEvery(updateTutorCategoryApiData, updateTutorCategoryApi)
  yield takeEvery(deleteTutorCategoryApiData, deleteTutorCategoryApi)
  yield takeEvery(activeInactiveTutorCategoryApiData, activeInactiveTutorCategoryApi)

  // Tutor Sub Category
  yield takeEvery(getTutorSubCategoryListApiData, getTutorSubCategoryListApi)
  yield takeEvery(getTutorSubCategoryDetailsApiData, getTutorSubCategoryDetailsApi)
  yield takeEvery(addTutorSubCategoryApiData, addTutorSubCategoryApi)
  yield takeEvery(updateTutorSubCategoryApiData, updateTutorSubCategoryApi)
  yield takeEvery(deleteTutorSubCategoryApiData, deleteTutorSubCategoryApi)
  yield takeEvery(activeInactiveTutorSubCategoryApiData, activeInactiveTutorSubCategoryApi)

  // Tutor Curriculum
  yield takeEvery(getTutorCurriculumListApiData, getTutorCurriculumListApi)
  yield takeEvery(getTutorCurriculumDetailsApiData, getTutorCurriculumDetailsApi)
  yield takeEvery(addTutorCurriculumApiData, addTutorCurriculumApi)
  yield takeEvery(updateTutorCurriculumApiData, updateTutorCurriculumApi)
  yield takeEvery(deleteTutorCurriculumApiData, deleteTutorCurriculumApi)
  yield takeEvery(activeInactiveTutorCurriculumApiData, activeInactiveTutorCurriculumApi)

  // Tutor List
  yield takeEvery(getTutorListApiData, getTutorListApi)
  yield takeEvery(getTutorDetailsApiData, getTutorDetailsApi)
  yield takeEvery(activeInactiveTutorApiData, activeInactiveTutorApi)
  yield takeEvery(tutorVerificationApiData, tutorVerificationApi)

  // State (tutor list filter)
  yield takeEvery(getTutorStateListApiData, getTutorStateListApi)

  // Country (common)
  yield takeEvery(getCountryListApiData, getCountryListApi)
}

export default tutorManagementSaga
